export const FORM_RESOURCE_NAME = 'form';
